import { motion } from "framer-motion";
import { IMG, pxFree } from "../data/site";
import { FadeUp, SectionHead } from "./Motion";
import InstagramFeed from "./InstagramFeed";

const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="mx-auto max-w-7xl px-5 py-32 md:px-10 md:py-40">
    <SectionHead
      index="07"
      kicker="Gallery"
      title={<>Golden, crisp & <em className="italic text-gold">unforgettable</em></>}
    />
    <div className="columns-2 gap-4 md:columns-3 md:gap-5 [column-fill:_balance]">
      {IMG.gallery.map((g, i) => (
        <FadeUp key={g.src || g.id} delay={(i % 3) * 0.08} className="mb-4 break-inside-avoid md:mb-5">
          <motion.figure
            data-testid={`gallery-item-${g.id || "interior"}`}
            whileHover="hover"
            className="group relative overflow-hidden rounded-xl border border-white/10"
          >
            <motion.img
              src={g.src || pxFree(g.id, 800)}
              alt={g.label}
              loading="lazy"
              variants={{ hover: { scale: 1.06 } }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="w-full object-cover"
            />
            <figcaption className="absolute inset-0 flex items-end bg-gradient-to-t from-ink/90 via-transparent to-transparent p-5 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
              <span className="font-serif text-xl text-white">{g.label}</span>
            </figcaption>
          </motion.figure>
        </FadeUp>
      ))}
    </div>
    <InstagramFeed />
  </section>
);

export default Gallery;
